import { FiDialogsService } from '../../../shared/fi-dialogs';
import { FiSnackBarService } from '../../../shared/fi-shared-services';
import { AppTextService } from '../../../shared/app-text/app-text.service';
import { ItemsListContainerBase } from '../../../components/items-list-container-base';
import { Component, OnInit, Input, Injector, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { FormReportInactiveColleaguesListData } from './fi-form-report-inactive-colleagues-list-data';
import { FiFormSharedService } from '../../../shared/fi-form-shared/fi-form-shared.service';
import { LoadingService } from '../../../shared/fi-loading/loading.service';
import { IFormReportInactiveColleague } from '../fi-form-report';
import { MatDialog } from '@angular/material/dialog';
import { FiStateNames } from '../../../shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-form-report-inactive-colleagues-list',
    template: `
        <mat-card class="fi-form-report-card">
            <mat-card-title class="BrandedBackgroundColor mat-card-title-text-center-container">
                <!--<div class="fi-form-report-back-button-wrapper">
                        <mat-icon (click)="goBack()" class="fi-form-report-back-icon cursor-pointer">
                            <span class="fa fa-chevron-left"></span>
                        </mat-icon>
                        <span (click)="goBack()" class="cursor-pointer">{{'back' | fiAppText}}</span>
                    </div>-->
                <span class="fi-form-report-title-text">{{ 'form.inactive_colleagues_header' | fiAppText }}</span>
                <div class="fi-form-report-additional-item"></div>
            </mat-card-title>

            <mat-card-content>
                <p class="fi-form-report-description-paragraph">
                    {{ 'form.inactive_colleagues_description' | fiAppText }}
                </p>
                <div class="fi-form-report-buttons-wrapper">
                    <button mat-raised-button (click)="showConfirmationDialog(ListData.SelectedItems, false)">
                        {{ 'button.remind_selected' | fiAppText }}
                    </button>
                    <button
                        mat-raised-button
                        class="button-margin BrandedBackgroundColor"
                        (click)="showConfirmationDialog(inactiveColleagues, true)"
                    >
                        {{ 'button.remind_all' | fiAppText }}
                    </button>
                </div>
                <div class="fi-form-report-item-list-wrapper">
                    <fi-items-list [settings]="ListData" [module]="[FiStateNames.Form._name]"></fi-items-list>
                </div>
            </mat-card-content>
        </mat-card>
    `,
    styleUrls: ['../fi-form-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiFormReportInactiveColleaguesListComponent
    extends ItemsListContainerBase<FormReportInactiveColleaguesListData>
    implements OnInit
{
    @Input() formId: number;
    @Input() inactiveColleagues: IFormReportInactiveColleague[];
    @Output() back = new EventEmitter();
    FiStateNames = FiStateNames;

    constructor(
        private injector: Injector,
        private appTextService: AppTextService,
        private matDialog: MatDialog,
        private fiDialogsService: FiDialogsService,
        private snackBar: FiSnackBarService,
        private formSharedService: FiFormSharedService,
        private fiLoadingService: LoadingService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => new FormReportInactiveColleaguesListData(this.injector), {
            noLocalSearch: true,
            showDelete: false,
        });
    }

    goBack() {
        this.back.emit();
    }

    protected LoadItems() {
        this.ListData.Data = this.inactiveColleagues;
        return Promise.resolve();
    }

    protected SetItemsCount() {
        return Promise.resolve(this.inactiveColleagues.length);
    }

    showConfirmationDialog(selectedUserList: IFormReportInactiveColleague[], isRemindAll: boolean) {
        if (selectedUserList.length) {
            let userIds = selectedUserList.map((user) => user.Id);

            let messageText = isRemindAll
                ? this.appTextService.get('form.reminder_description_all')
                : this.appTextService.get('form.reminder_description_selected');
            messageText = messageText.replace('<number of selected users>', `${userIds.length}`);

            this.fiDialogsService
                .confirm({
                    headerText: this.appTextService.get('form.reminder_header'),
                    messageText: messageText,
                    yesButtonText: this.appTextService.get('form.reminder_send'),
                    config: {
                        width: '500px',
                    },
                })
                .onYesButtonClick(() => this.sendReminder(selectedUserList));
        }
    }

    sendReminder(selectedUserList: IFormReportInactiveColleague[]) {
        const userIds = selectedUserList.map((item) => item.Id);
        this.fiLoadingService
            .trackPromise(this.formSharedService.sendFormReminders(this.formId, userIds))
            .then((reminderSentDate) => {
                this.ListData.Data.forEach((item) => {
                    if (userIds.indexOf(item.Id) !== -1) {
                        item.LastReminderSent = reminderSentDate;
                    }
                });

                this.ListData.updateReminderSentContent();
                this.snackBar.showSnackbar({
                    textMessage: this.appTextService.get('form.reminder_sent'),
                    buttonText: this.appTextService.get('common.close'),
                });
            });
    }
}
